module.exports = __webpack_public_path__ + "static/SVHome-02-52c506a34ee0a7fb6ff91e167d90bcbb.png";